module.exports = __webpack_public_path__ + "img/19.710bfec2.png";